<ng-template #prevButton>
    <bil-button [style]="'ghost'" [color]="'primary'"> Indietro </bil-button>
</ng-template>
<ng-template #nextButton>
    <bil-button [style]="'button'" [color]="'primary'"> Avanti </bil-button>
</ng-template>
<ng-template #doneButton>
    <bil-button [style]="'button'" [color]="'primary'"> Chiudi </bil-button>
</ng-template>
<ng-template #counter let-step="step" let-total="total">
    <span class="app-tour-text"> {{ step }} di {{ total }} </span>
</ng-template>
<ng-template
    #customContent
    let-text="descr"
    let-title="title"
    let-link="link"
    let-link1="link1"
    let-linkText="linkText"
    let-linkText1="linkText1"
>
    <div class="tour-custom-content">
        <div class="titleAccordion tour-custom-content-title">{{ title }}</div>
        <div class="app-tour-text" style="margin-bottom: 8px">
            {{ text }}
        </div>
        @if (link) {
            <div class="app-tour-text" style="margin-top: 8px">
                <i class="app-tour-cta" id="{{ link }}">
                    @if (linkText) {
                        <span>{{ linkText }}</span>
                    } @else {
                        <span>Vedi video di approfondimento</span>
                    }
                    <ng-template #noLinkText
                        ><span>Vedi video di approfondimento</span></ng-template
                    >
                </i>
            </div>
        }
        @if (link1) {
            <div class="app-tour-text" style="margin-top: 4px">
                <i class="app-tour-cta" id="{{ link1 }}">
                    @if (linkText1) {
                        <span>{{ linkText1 }}</span>
                    } @else {
                        <span> Vedi secondo video di approfondimento </span>
                    }
                    <ng-template #noLinkText1
                        ><span>
                            Vedi secondo video di approfondimento
                        </span></ng-template
                    >
                </i>
            </div>
        }
    </div>
</ng-template>
